import { TBookingContext } from '@providers/booking/types'
import { InvoicePeriodAdminDto, PetInvoiceRelationAdminDto } from 'service-api/src/types'
import { dayToJSDate, formatDateRangeWithYear } from 'components-ui/src'

export const petsName = (petInvoiceRelation: PetInvoiceRelationAdminDto[] = [], locationPetProfileIds: string[]) => {
  const names = new Set<string>()
  petInvoiceRelation.forEach((relation) => {
    if (locationPetProfileIds.some((id) => id === relation.invoicePet?.locationPetProfile?.id)) {
      names.add(relation.invoicePet?.locationPetProfile?.displayName ?? '')
    }
  })
  return names.size > 0 ? Array.from(names).join(', ') : ''
}

export const datesFormated = (period?: InvoicePeriodAdminDto, isOverNight: boolean = false) => {
  if (!period) return ''
  const { startDate, endDate } = period
  return isOverNight
    ? formatDateRangeWithYear(dayToJSDate(startDate), dayToJSDate(endDate))
    : formatDateRangeWithYear(dayToJSDate(startDate))
}

export const getReservationPetIds = (state: TBookingContext) =>
  state.groups
    .flatMap((group) => group.pets)
    .filter((pet) => pet.room !== 0)
    .map((pet) => pet.id)
    .filter(Boolean)
